import React, { Suspense, useEffect, useState } from 'react';
import Loading from '../../components/Loading';

export const Suspenser = ({ children, show = true }) => {
  if (!show) {
    throw new Promise(() => {
    });
  }
  return children;
};

export const SuspenserMinDelay = ({ show, children, minShowDelayInMilliseconds = 0 }) => {
  const [a, setA] = useState(show);
  const [startFunction] = useState(performance.now());

  useEffect(() => {
    if (show) {
      const endFunction = performance.now();
      const functionTime = endFunction - startFunction;
      if (functionTime >= minShowDelayInMilliseconds) {
        setA(true);
      } else {
        setTimeout(() => {
          setA(true);
        }, minShowDelayInMilliseconds - functionTime);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);
  return (
    <Suspenser show={a}>
      {children}
    </Suspenser>
  );
};

export const SuspenseLoaderWrapper = ({ children }) => (
  <Suspense fallback={<Loading />}>
    {children}
  </Suspense>
);
